module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


/*****************
 ** WEBPACK FOOTER
 ** external "window"
 ** module id = 21
 ** module chunks = 0
 **/